/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterTransactionDto } from '../../models/center-transaction-dto';
import { CreateCenterTransactionDto } from '../../models/create-center-transaction-dto';

export interface CenterTransactionControllerCreate$Params {
  centerId: string;
      body: CreateCenterTransactionDto
}

export function centerTransactionControllerCreate(http: HttpClient, rootUrl: string, params: CenterTransactionControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterTransactionDto>> {
  const rb = new RequestBuilder(rootUrl, centerTransactionControllerCreate.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterTransactionDto>;
    })
  );
}

centerTransactionControllerCreate.PATH = '/api/center-transaction';
